// extracted by mini-css-extract-plugin
export default {"subheader":"ModificationRulesPane_subheader__+36Fi"};